var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"holding_page"}},[_vm._v(" Sorry! This page is under development. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }